import {Component, ViewChild} from '@angular/core';
import { DisplayServiceProvider } from '../../../../core/services/display-service/display-service';
import { ENVIRONMENT } from '../../../../../../environments/environment';
import {IonicPage, ModalController, NavParams} from 'ionic-angular';
import { ListRendererComponent } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { SimpleFilterSet } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/simple-filter-set.interface';
import { StorageServiceProvider } from '../../../../core/services/storage-service/storage-service';
import { TextServiceProvider } from '../../../../core/services/text-service/text-service';
import { UserTask } from '../../../interfaces/user-task.interface';
import { UserTaskPreviewPage } from '../../user-task-preview/user-task-preview';
import {UserTaskService} from "../../../services/user-task.service/user-task.service";
import {Subscription} from "rxjs";
import {
  ProcessAction
} from "../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/process-action.interface";
import {
  FormField
} from "../../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface";
import {
  Utils
} from "../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/utils.class";
import {
  ProcessFormService
} from "../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process-form.service";
import {
  ProcessService
} from "../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process.service";
import {AuthenticationServiceProvider} from "../../../../core/services/authentication-service/authentication-service";
import {
  FormDefinition
} from "../../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-definition.interface";
import {
  UserTaskPreviewConfig,
  UserTaskTabConfig
} from "../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/user-task-config.interface";

@IonicPage()
@Component({
  selector: 'page-user-task-template-list',
  templateUrl: 'user-task-template-list.html',
})
export class UserTaskTemplateListPage {
  @ViewChild(ListRendererComponent) list: ListRendererComponent;
  private config: UserTaskTabConfig;
  public db: any;
  public engineUrl = ENVIRONMENT.engineUrl;
  public filters: SimpleFilterSet;
  public selectedParent;
  private sub: Subscription;
  private baseUrl = ENVIRONMENT.engineUrl;
  private loading = false;
  private taskTypeName: string;
  private userTaskPreviewConfig: UserTaskPreviewConfig;

  constructor(
    private displayService: DisplayServiceProvider,
    private modalCtrl: ModalController,
    private storageService: StorageServiceProvider,
    public textService: TextServiceProvider,
    private navParams: NavParams,
    private userTaskService: UserTaskService,
    private processFormService: ProcessFormService,
    private processService: ProcessService
  ) {}

  ngOnInit() {
    this.db = this.storageService.db;
    this.config = this.navParams.data.config;
    this.taskTypeName = this.config.name;
    this.userTaskPreviewConfig = this.config.previewTask;
    this.selectedParent = this.navParams.data.parent
    const filterConfig = this.config.filter;
    if (filterConfig && filterConfig.filters) {
      this.filters = filterConfig.filters;
    }
    this.sub = this.userTaskService.reloadUserTaskListEventEmitter.subscribe(userTaskType => {
      userTaskType === this.taskTypeName && this.list.reload()
    });
  }

  public goTo($event: { viewId: string; element: UserTask }) {
    const modal = this.modalCtrl.create(UserTaskPreviewPage,
      {
        userTask: $event.element,
        taskType: this.taskTypeName,
        disabled: !this.userTaskPreviewConfig.editable,
        assignButtonAvailable: !!this.userTaskPreviewConfig.assignButtonAvailable
      });
    modal.onDidDismiss(() => {
      this.list.reload();
    });
    modal.present();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onButtonClick(event: ProcessAction) {
    this.appendFieldsFromMappingParentObjectIntoElement(event);
    this.handleProcessAction(event.process.processKey, event.element);
  }

  private handleProcessAction(processKey: string, data: Object): void {
    this.processService
      .getProcessWithForm(this.baseUrl, processKey)
      .subscribe((formDefinition: FormDefinition) => {
        const fields = formDefinition.form
        const formName = formDefinition.formName
        this.processService
          .initProcess(this.baseUrl, {formName: formName, formJson: this.getFormJson(fields, data), key: processKey })
          .subscribe(() => {
            this.list.reload();
            this.changeLoadingStatus(true);
          });
      });
  }

  private getFormJson(formJson: FormField[], data: any): any {
    if (!data) {
      return formJson;
    }
    return this.processFormService.mapFormData(this.config, formJson, data);
  }

  private appendFieldsFromMappingParentObjectIntoElement($event: { process?: any; element?: Object; }) {
    if (this.config.formMappingFromParentObject && this.list.getParams()) {
      if (!$event.element) {
        $event.element = {};
      }
      for (let key in this.config.formMappingFromParentObject) {
        let valueExpression = this.config.formMappingFromParentObject[key];
        let value = Utils.evaluateVariablesString(valueExpression, this.selectedParent);

        $event.element[key] = value
      }
    }
  }

  changeLoadingStatus(event: boolean) {
    this.loading = event;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-template-list/user-task-template-list.ts